export enum AvailabilityItemTypeEnum {
    Category = "CATEGORIA",
    Subcategory = "SUBCATEGORIA",
    MenuItem = "PRODUCTO",
}
